module.exports = __webpack_public_path__ + "static/media/key-focus.5e0d408b.svg";